import {Separator, SpecialKey, Mark, Sign} from './types';

export function isSeparator(char: string|Mark): char is Separator {
  return Object.values(Separator).some(separator => separator === char);
}

export function isSpecialKey(key: string): key is SpecialKey {
  return Object.values(SpecialKey).some(sepcial => sepcial === key);
}

export function isMark(char: string|Mark): char is Mark {
  return char instanceof Mark;
}

export function isSign(char: string|Mark): char is Sign {
  return Object.values(Sign).some(sign => sign === char);
}
